import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#37bd00',
        danger: '#eb5757'
      },
      dark: {
        primary: '#000000',
        danger: '#eb5757'
      }
    }
  }
}

export default new Vuetify(opts)
